function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { useCallback, useEffect, useState } from 'react';
import { useErrorHandling } from '../hooks/useErrorHandling';
const reportTemplateService = {
  useGet(reportTemplateId) {
    const [rndReportTemplate, setRndReportTemplate] = useState(null);
    const fetchRndReportTemplate = useErrorHandling(useCallback(async () => {
      const template = await reportTemplateService.get(reportTemplateId);
      setRndReportTemplate(template);
    }));
    useEffect(async () => {
      await fetchRndReportTemplate();
    }, [reportTemplateId]);
    return [rndReportTemplate, setRndReportTemplate];
  },
  all() {
    let search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    //search is used only for Italy at the moment
    return fetch("/api/report_templates".concat(search), request.get);
  },
  get(templateId) {
    return fetch("/api/report_templates/".concat(templateId), request.get);
  },
  create(report_template, templateType) {
    report_template = templateType ? _objectSpread(_objectSpread({}, report_template), {}, {
      template_type: templateType
    }) : report_template; // Italy
    return fetch('/api/report_templates/', _objectSpread(_objectSpread({}, request.post), {}, {
      body: JSON.stringify({
        report_template
      })
    }));
  },
  update(id, report_template) {
    return fetch("/api/report_templates/".concat(id), _objectSpread(_objectSpread({}, request.put), {}, {
      body: JSON.stringify({
        report_template
      })
    }));
  },
  updateWithCategories(id, report_template) {
    report_template.report_template_categories_attributes || (report_template.report_template_categories_attributes = report_template.report_template_categories);
    return reportTemplateService.update(id, report_template);
  },
  delete(id) {
    return fetch("/api/report_templates/".concat(id), _objectSpread({}, request.delete));
  }
};
export default reportTemplateService;